const topics = [
  { id: 1, name: '顶流塌房', hot: '12.6万', color: 'primary' },
  { id: 2, name: '深夜密会', hot: '9.8万', color: 'accent' },
  { id: 3, name: '婚变内幕', hot: '8.3万', color: 'secondary' },
  { id: 4, name: '偷税漏税', hot: '7.1万', color: 'primary' },
  { id: 5, name: '综艺翻车', hot: '6.5万', color: 'accent' },
  { id: 6, name: '私联粉丝', hot: '5.9万', color: 'secondary' },
  { id: 7, name: '潜规则曝光', hot: '4.7万', color: 'primary' },
  { id: 8, name: '录音门', hot: '4.2万', color: 'accent' },
  { id: 9, name: '聊天记录泄露', hot: '3.8万', color: 'secondary' },
];

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200/60 hover:bg-primary-200/60',
  accent: 'bg-accent-100 text-accent-700 border-accent-200/60 hover:bg-accent-200/60',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200/60 hover:bg-secondary-200/60',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium cursor-pointer transition-colors ${colorMap[topic.color]}`}
            >
              <i className="ri-hashtag text-base"></i>
              <span className="whitespace-nowrap">{topic.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{topic.hot}</span>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-foreground-400 mt-6">
          话题热度基于站内搜索及讨论量实时计算，每小时更新
        </p>
      </div>
    </section>
  );
}